import Costs from "./Costs";
import Interval from "./Interval";

export default {
  COSTS: Costs,
  INTERVAL: Interval,
};
